export default function ($scope, $state, $stateParams, accountDetails) {
    // How to get user id
    const userId = $stateParams.userId;

    $scope.recordNotFetched = true;
    $scope.errorOccured = false;

    accountDetails(userId)
        .then(account => {
            $scope.recordNotFetched = false;
            $scope.errorsOccurred = false;
            $scope.accountDetails = account;
        })
        .catch(() => {
            $scope.recordNotFetched = true;
            $scope.errorsOccurred = true;
        });
}



// WEBPACK FOOTER //
// ./Client/app/account/controllers/details/accountDetailsCtrl.js